export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/InProcess.db2176db.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};